<template>
  <div>
    <h4>Admin Pages</h4>
    <Accounts />
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import Component from "vue-class-component";
import Accounts from "./Accounts.vue";
import { RoleStore } from "@/store";

@Component({
  name: "Admin",
  components: {
    Accounts
  }
})
export default class Admin extends Vue {
  created() {
    if (!RoleStore.isAnAdmin) {
      this.$router.push("/profile");
    }
  }
}
</script>
